<div [formGroup]="form">
    <mat-form-field class="fill-w">
        <mat-label [attr.for]="input.key">{{input.label}} <span class="error-text" *ngIf="!isValid">required</span></mat-label>
        <input [readonly]="disabled" *ngIf="input.controlType ==='textbox' && input.type === 'Text'" matInput [formControlName]="input.key" [id]="input.key" type="text" >
        <input [readonly]="disabled" *ngIf="input.controlType==='textbox' && input.type === 'Number'" matInput [formControlName]="input.key" [id]="input.key" numberOnly type="text" >
        <button *ngIf="input.controlType ==='textbox' && input.type !== 'Date' && !disabled" matSuffix mat-icon-button aria-label="Clear" [matTooltipPosition]="'above'" matTooltip="Clear Content" (click)="clearValue()">
            <mat-icon>close</mat-icon>
        </button>
        <input [readonly]="disabled" *ngIf="input.controlType==='textbox' && input.type === 'Date'" matInput [formControlName]="input.key" [id]="input.key" type="date">
        <mat-select [disabled]="disabled"  *ngIf="input.controlType==='dropdown'" [formControlName]="input.key" [id]="input.key">
            <mat-option *ngFor="let opt of input.options" [value]="opt.value" >
                {{opt.value}}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>